import React from 'react';
import Sidebar from './Sidebar';

const TITLES = {
  '/dashboard': 'Dashboard',
  '/inventory': 'Inventory Management',
  '/products': 'Product Management',
  '/billing': 'New Invoice',
  '/invoices': 'Invoices',
  '/users': 'User Management',
  '/reports': 'Reports & Analytics',
};

export default function Layout({ children, title }) {
  const today = new Date().toLocaleDateString('en-IN', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });

  return (
    <div className="app-shell" style={{ position: 'relative' }}>
      <Sidebar />
      <div className="main-area">
        <div className="topbar">
          <div className="topbar-title">{title}</div>
          <div style={{ fontSize: 11, color: '#9e9e9e' }}>{today}</div>
        </div>
        <div className="content-area">{children}</div>
      </div>
    </div>
  );
}

export { TITLES };
